import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const triggerProductFamilyEmbeddings = {
  name: "triggerProductFamilyEmbeddings" as const,
  input: z.object({
    teamId: zExt.objectId(),
    skipExistingEmbeddings: z.boolean().optional(),
  }),
  output: z.object({
    success: z.boolean(),
    workflowId: z.string().nullable(),
    error: z.string().nullable(),
  }),
};
